import { Injectable, inject } from '@angular/core';
import { Observable, from, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { O2OStuckStockHoldAlertsService as O2oStuckAlertApiService } from '@app/api/order-service/api/o2OStuckStockHoldAlerts.service';
import { O2oStuckAlertSearchDTO } from '@app/api/order-service/model/o2oStuckAlertSearchDTO';
import { PageInfoO2oStuckAlertVO } from '@app/api/order-service/model/pageInfoO2oStuckAlertVO';
import { BlobConverterUtil } from '@shared/utils/blob-converter.util';
import { O2oStuckAlert, O2oStuckAlertPageResult, O2oStuckAlertSearchParams } from '../o2o-stuck-alert.model';

const JSON_ACCEPT_OPTIONS = { httpHeaderAccept: 'application/json' } as const;

@Injectable({
  providedIn: 'root',
})
export class O2oStuckAlertService {
  private readonly api = inject(O2oStuckAlertApiService);

  pageAlerts(params: O2oStuckAlertSearchParams): Observable<O2oStuckAlertPageResult> {
    const request: O2oStuckAlertSearchDTO = { ...params };
    return this.api.page1(request, 'body', false, JSON_ACCEPT_OPTIONS as any).pipe(
      switchMap((response: PageInfoO2oStuckAlertVO | Blob) =>
        this.handleBlobResponse<PageInfoO2oStuckAlertVO>(response),
      ),
      map((response) => ({
        alerts: (response.pageContent || []) as O2oStuckAlert[],
        totalRecords: response.totalElements || 0,
      })),
      catchError((error) => this.handleBlobError(error)),
    );
  }

  private handleBlobResponse<T>(response: Blob | T): Observable<T> {
    if (response instanceof Blob) {
      return from(BlobConverterUtil.convertToJson(response)) as Observable<T>;
    }
    return of(response as T);
  }

  private handleBlobError(error: unknown): Observable<never> {
    const err = error as { error?: unknown };
    if (err?.error instanceof Blob) {
      return from(BlobConverterUtil.convertToJson(err.error)).pipe(
        catchError(() => throwError(() => error)),
        switchMap((parsedError: unknown) =>
          throwError(() => ({ ...(error as object), error: parsedError })),
        ),
      );
    }
    return throwError(() => error);
  }
}
